import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import LoadingSpinner from "./components/LoadingSpinner";
import ToastProvider from "./components/ToastProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import SeoHead from "./components/SeoHead";
import GoogleAnalytics from "./components/GoogleAnalytics";
import { isElectron } from "./utils/electronEnv";

const recaptchaSiteKey = isElectron() ? "" : process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
const recaptchaUseNet = process.env.REACT_APP_RECAPTCHA_USE_RECAPTCHA_NET === "true";

const DoctorLogin = lazy(() => import("./pages/auth/DoctorLogin"));
const DoctorRegister = lazy(() => import("./pages/auth/DoctorRegister"));
const DoctorDashboard = lazy(() => import("./pages/doctor/DoctorDashboard"));
const DoctorProfile = lazy(() => import("./pages/doctor/DoctorProfile"));

/**
 * Standalone doctor SPA (deploy at doctor.scribeinai.com).
 * No hostname branching — this bundle only serves the provider portal.
 */
export default function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaSiteKey}
        useEnterprise={false}
        useRecaptchaNet={recaptchaUseNet}
        scriptProps={{ async: true, defer: true }}
      >
        <ToastProvider>
          <div className="min-h-screen flex flex-col">
            <GoogleAnalytics />
            <SeoHead page="home" />
            <main className="flex-1 w-full min-w-0 overflow-x-hidden">
              <Suspense fallback={<LoadingSpinner fullScreen text="Loading…" />}>
                <Routes>
                  <Route path="/" element={<DoctorLogin />} />
                  <Route path="/login" element={<DoctorLogin />} />
                  <Route path="/register" element={<DoctorRegister />} />
                  <Route
                    path="/doctor-dashboard"
                    element={
                      <ProtectedRoute tokenOnly>
                        <DoctorDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/DoctorDashboard"
                    element={
                      <ProtectedRoute tokenOnly>
                        <DoctorDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute tokenOnly>
                        <DoctorProfile />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>
            </main>
          </div>
        </ToastProvider>
      </GoogleReCaptchaProvider>
    </Router>
  );
}
